export function postMessage(type: string, data = {}) {
	window.top?.postMessage(
		{
			type,
			...data
		},
		window.location.toString()
	);
}
